export default "__VITE_ASSET__CtpS6AIE__"